<a class="floating"><mat-icon svgIcon="add_property"></mat-icon></a>